import React, { useState, useEffect } from "react";
import {
    Modal,
    Box,
    Typography,
    Button,
    IconButton,
    TextField,
    MenuItem
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import FilterValueInput from "./FilterValueInput";

const FilterModal = ({ open, onClose, moduleFields, filters, setFilters, module }) => {


    const FilterOperator = {
        Equal: 0,
        NotEqual: 1,
        Contains: 2,
        NotContains: 3,
        StartsWith: 4,
        EndsWith: 5,
        IsEmpty: 6,
        IsNotEmpty: 7,
        IsNull: 8,
        IsNotNull: 9,
        GreaterThan: 10,
        GreaterThanOrEqual: 11,
        LessThan: 12,
        LessThanOrEqual: 13,
        Between: 14,
    };

    // Local state for modal's filters
    const [selectedFilters, setSelectedFilters] = useState([{ fieldName: "", operator: "", value: "" }]);

    // Sync modal state with props when it opens
    useEffect(() => {
        if (open) {
            console.log("modal: ", filters);
            setSelectedFilters(filters.length ? filters : [{ fieldName: "", operator: "", value: "" }]);
        }
    }, [open, filters]);

    const operatorsByType = {
        String: [
            { label: "Equals", value: FilterOperator.Equal },
            { label: "Contains", value: FilterOperator.Contains },
            { label: "Starts With", value: FilterOperator.StartsWith },
            { label: "Ends With", value: FilterOperator.EndsWith },
        ],
        Decimal: [
            { label: "Equals", value: FilterOperator.Equal },
            { label: "Greater Than", value: FilterOperator.GreaterThan },
            { label: "Less Than", value: FilterOperator.LessThan },
        ],
        Enum: [
            { label: "Is", value: FilterOperator.Equal },
            { label: "Is Not", value: FilterOperator.NotEqual },
        ],
        FK: [
            { label: "Is", value: FilterOperator.Equal },
            { label: "Is Not", value: FilterOperator.NotEqual },
        ],
        DateTime: [
            { label: "Between", value: FilterOperator.Between },
            { label: "Before", value: FilterOperator.LessThan },
            { label: "After", value: FilterOperator.GreaterThan },
            { label: "On", value: FilterOperator.Equal },
        ],
    };

    const handleAddFilter = () => {
        setSelectedFilters([...selectedFilters, { fieldName: "", operator: "", value: "" }]);
    };

    const handleRemoveFilter = (index) => {
        setSelectedFilters(selectedFilters.filter((_, i) => i !== index));
    };

    const handleChange = (index, key, value) => {
        const updatedFilters = [...selectedFilters];
        updatedFilters[index][key] = value;
        setSelectedFilters(updatedFilters);
    };

    const handleSave = () => {
        // Remove empty filters and update parent state
        console.log("Save ", selectedFilters);
        setFilters(selectedFilters.filter(f => f.fieldName && f.operator !== undefined && f.operator !== null && f.value));
        onClose();
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: 0, // Position the modal at the top
                    left: "50%",
                    transform: "translateX(-50%)", // Only center horizontally
                    width: 700,
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 3,
                    borderRadius: "0 0 8px 8px",
                }}
                >
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                Add Filter
            </Typography>

            <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                This filter will be available in reports view for quick updates.
            </Typography>

            {selectedFilters.map((filter, index) => {
                const selectedField = moduleFields.find(f => f.fieldName === filter.fieldName);
                return (
                    <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 1 }}>
                        <Typography>{index + 1}</Typography>

                        {/* Field Selector */}
                        <TextField
                            select
                            value={filter.fieldName}
                            onChange={(e) => handleChange(index, "fieldName", e.target.value)}
                            size="small"
                            sx={{ flex: 0.6 }}
                        >
                            {moduleFields.map((field) => (
                                <MenuItem key={field.id} value={field.fieldName}>
                                    {field.displayName}
                                </MenuItem>
                            ))}
                        </TextField>

                        {/* Operator Selector */}
                        <TextField
                            select
                            value={filter.operator}
                            onChange={(e) => handleChange(index, "operator", e.target.value)}
                            size="small"
                            sx={{ flex: 0.6 }}
                            disabled={!selectedField}
                        >
                            {selectedField &&
                                operatorsByType[selectedField.dataType]?.map((operator) => (
                                    <MenuItem key={operator.value} value={operator.value}>
                                        {operator.label}
                                    </MenuItem>
                                ))}
                        </TextField>

                        {/* Field Value Input */}
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            <FilterValueInput selectedField={selectedField} filter={filter} index={index} handleChange={handleChange} module={module} />
                        </Box>


                        {/* Remove Button */}
                        {selectedFilters.length > 1 && (
                            <IconButton onClick={() => handleRemoveFilter(index)} color="error">
                                <RemoveCircleOutlineIcon />
                            </IconButton>
                        )}

                        {/* Add Button */}
                        {index === selectedFilters.length - 1 && (
                            <IconButton onClick={handleAddFilter} color="success">
                                <AddCircleOutlineIcon />
                            </IconButton>
                        )}
                    </Box>
                );
            })}

            {/* Actions */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
                <Button onClick={onClose} variant="outlined" sx={{ mr: 1 }}>
                    Cancel
                </Button>
                <Button variant="contained" onClick={handleSave}>
                    Save
                </Button>
            </Box>
        </Box>
        </Modal >
    );
};


export default FilterModal;
